import React from 'react'

const componentPromise = import('./detail' /* webpackChunkName: "detail"*/)

const Component = React.lazy(() => componentPromise)

export default Component
